import React from 'react';
import { Card } from './card';
import { ReactComponent as PatientIcon } from './../../../assets/icons/patient.svg';
import { LoadText } from '../load/loadText';
import { css } from '../../../services/css';


import styles from './acceptingNewPatientsCard.module.css';

export const AcceptingNewPatientsCard = ({accepting = true, loading = false}) => {
    return <Card className={css(styles.Card, accepting ? styles.Accepting : styles.NotAccepting)}>
        <div className='icon text-color'>
            <PatientIcon />
        </div>
        {
            (loading) ?
            <LoadText dark={false} max={100} min={60} strength={2} />
            :
            (accepting) ?
            'Accepting New Patients'
            : 'Not Accepting New Patients'
        }
    </Card>;
}